import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { RowCentered, SubmitWrapper } from 'pages/Login/style';
import { Button } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';

import { TermsAndConditionsTitle } from './style';

const TermsAndConditions = ({ acceptTC }) => {
  const { t } = useTranslation();

  return (
    <>
      <TermsAndConditionsTitle>
        <MainFont configuration={{ fontSize: 24 }} type="3">
          {t('complete_personal_data')}
        </MainFont>
      </TermsAndConditionsTitle>
      <RowCentered>
        <SubmitWrapper>
          <Button variant="login" onClick={() => {}}>
            {t('submit')}
          </Button>
        </SubmitWrapper>
      </RowCentered>
    </>
  );
};

TermsAndConditions.propTypes = {
  acceptTC: PropTypes.func
};

export default connect(
  () => ({}),
  dispatch => ({
    acceptTC: () => dispatch()
  })
)(TermsAndConditions);
